import jsPDF from 'jspdf';

export function generateReceiptPDF(receipt) {
  const doc = new jsPDF({ unit: 'mm', format: 'a5' });
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 15;
  let y = 20;

  // Header
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text('SIGNATURE PSC COACHING CENTRE', pageWidth / 2, y, { align: 'center' });
  y += 6;
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text('Palachira, Varkala, Kerala | Phone: 8281583404', pageWidth / 2, y, { align: 'center' });
  y += 4;

  // Gold line
  doc.setDrawColor(212, 175, 55);
  doc.setLineWidth(0.8);
  doc.line(margin, y, pageWidth - margin, y);
  y += 8;

  // Receipt title
  doc.setFontSize(13);
  doc.setFont('helvetica', 'bold');
  doc.text('FEE RECEIPT', pageWidth / 2, y, { align: 'center' });
  y += 8;

  // Receipt No + Date
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text(`Receipt No: ${receipt.receipt_no}`, margin, y);
  doc.text(`Date: ${receipt.paid_date?.split('T')[0] || ''}`, pageWidth - margin, y, { align: 'right' });
  y += 8;

  // Details table
  const details = [
    ['Student ID', receipt.student_id],
    ['Student Name', receipt.student_name],
    ['Batch', (receipt.batch || '').replace('_', ' ').toUpperCase()],
    ['Fee Type', (receipt.type || '').charAt(0).toUpperCase() + (receipt.type || '').slice(1)],
    ['Month / Year', `${receipt.month} ${receipt.year}`],
    ['Payment Method', (receipt.payment_method || '').toUpperCase()],
    ['Collected By', receipt.collected_by || ''],
  ];

  doc.setFontSize(10);
  details.forEach(([label, value]) => {
    doc.setFont('helvetica', 'bold');
    doc.text(label, margin, y);
    doc.setFont('helvetica', 'normal');
    doc.text(`: ${value}`, margin + 42, y);
    y += 6;
  });

  y += 5;

  // Amount box
  doc.setDrawColor(212, 175, 55);
  doc.setFillColor(255, 250, 230);
  doc.roundedRect(margin, y, pageWidth - 2 * margin, 18, 2, 2, 'FD');
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(100, 100, 100);
  doc.text('Amount Paid', pageWidth / 2, y + 6, { align: 'center' });
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  doc.text(`Rs. ${receipt.amount}/-`, pageWidth / 2, y + 14, { align: 'center' });
  y += 25;

  // Footer
  doc.setDrawColor(212, 175, 55);
  doc.setLineWidth(0.3);
  doc.line(margin, y, pageWidth - margin, y);
  y += 5;
  doc.setFontSize(8);
  doc.setFont('helvetica', 'italic');
  doc.setTextColor(100, 100, 100);
  doc.text('This is a computer-generated receipt.', pageWidth / 2, y, { align: 'center' });
  y += 4;
  doc.text('SIGNATURE PSC COACHING CENTRE - 10+ Years of Excellence', pageWidth / 2, y, { align: 'center' });

  return doc;
}

export function downloadReceiptPDF(receipt) {
  const doc = generateReceiptPDF(receipt);
  const fileName = `Receipt_${receipt.student_id}_${receipt.month}_${receipt.year}.pdf`;
  doc.save(fileName);
}

export function shareReceiptPDF(receipt) {
  const doc = generateReceiptPDF(receipt);
  const blob = doc.output('blob');
  const fileName = `Receipt_${receipt.student_id}_${receipt.month}_${receipt.year}.pdf`;

  // Try native share if available
  if (navigator.share && navigator.canShare) {
    const file = new File([blob], fileName, { type: 'application/pdf' });
    navigator.share({
      title: `Fee Receipt - ${receipt.student_name}`,
      text: `Fee receipt for ${receipt.month} ${receipt.year}`,
      files: [file]
    }).catch(() => {
      // Fallback to download
      doc.save(fileName);
    });
  } else {
    // Fallback: download
    doc.save(fileName);
  }
}
